var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { CompletedStep, ProcessStep } from 'Components.Structure';
import { Select } from 'Components.Form';
import { vehicleTypes } from 'Data';
import { injectIntl } from 'Intl';
var ConfirmVehicleTypeProcessStep = /** @class */ (function (_super) {
    __extends(ConfirmVehicleTypeProcessStep, _super);
    function ConfirmVehicleTypeProcessStep(props) {
        var _this = _super.call(this, props) || this;
        _this.handleConfirm = function () {
            var vehicleType = _this.state.vehicleType;
            if (vehicleType == null)
                return;
            _this.setState({
                confirmed: true,
            });
            _this.props.onConfirm(parseInt(vehicleType.value, 10));
        };
        _this.handleEdit = function () {
            _this.props.onEdit();
            _this.setState({
                confirmed: false,
            });
        };
        _this.handleVehicleTypeChange = function (option) {
            _this.setState({
                vehicleType: option,
            });
        };
        _this.resolveVehicleLabel = function (vehicleType) {
            var stringVehicleType = vehicleType.toString();
            var option = _this.state.options.find(function (o) { return o.value === stringVehicleType; });
            if (option == null)
                return '-';
            return option.label;
        };
        _this.state = {
            confirmed: false,
            loading: true,
            vehicleType: null,
            options: [],
        };
        return _this;
    }
    ConfirmVehicleTypeProcessStep.prototype.componentDidMount = function () {
        this.setVehicleTypes();
    };
    ConfirmVehicleTypeProcessStep.prototype.setVehicleTypes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, vehicle, intl, type, foundVehicleType;
            return __generator(this, function (_b) {
                _a = this.props, vehicle = _a.vehicle, intl = _a.intl;
                type = vehicle.type;
                foundVehicleType = vehicleTypes.find(function (o) { return o.value === type; });
                this.setState({
                    options: vehicleTypes.map(function (o) { return ({ label: intl.formatMessage(o.intlKey), value: o.value.toString() }); }),
                    loading: false,
                    vehicleType: foundVehicleType
                        ? { label: intl.formatMessage(foundVehicleType.intlKey), value: foundVehicleType.value.toString() }
                        : null,
                });
                return [2 /*return*/];
            });
        });
    };
    ConfirmVehicleTypeProcessStep.prototype.render = function () {
        var _a = this.state, confirmed = _a.confirmed, loading = _a.loading, vehicleType = _a.vehicleType, options = _a.options;
        var _b = this.props, label = _b.label, baseId = _b.baseId, intl = _b.intl;
        return (React.createElement(ProcessStep, { baseId: baseId, label: label, subtitle: intl.formatMessage('confirmVehicleType.description'), confirmed: confirmed, loading: loading, confirmDisabled: vehicleType == null, onConfirm: this.handleConfirm, onEditStep: this.handleEdit, activeContent: (React.createElement(Select, { id: "".concat(baseId, "_vehicleType_select"), options: options, value: vehicleType, onChange: this.handleVehicleTypeChange })), confirmedContent: (React.createElement(React.Fragment, null, this.props.vehicleType && (React.createElement(CompletedStep, { title: this.resolveVehicleLabel(this.props.vehicleType), subtitle: intl.formatMessage('confirmVehicleType.confirmation') })))) }));
    };
    return ConfirmVehicleTypeProcessStep;
}(React.Component));
export default injectIntl(ConfirmVehicleTypeProcessStep);
